import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const SENSITIVE_QUERY_KEYS = new Set([
  'token',
  'access_token',
  'id_token',
  'refresh_token',
  'code',
  'key',
  'api_key',
  'apikey',
  'auth',
  'authorization',
])

export function redactSensitiveUrl(value?: string | null): string | undefined {
  if (!value) return undefined

  try {
    const url = new URL(value, window.location.origin)
    for (const key of [...url.searchParams.keys()]) {
      if (SENSITIVE_QUERY_KEYS.has(key.toLowerCase())) {
        url.searchParams.delete(key)
      }
    }
    return url.toString()
  } catch {
    return value
  }
}
